import { useSuspenseQuery } from "@apollo/client/react";
import {
  GetDbpjKitWorkerJobsDocument,
  type GetDbpjKitWorkerJobsQuery,
  type GetDbpjKitWorkerJobsQueryVariables,
} from "~/features/dbpjkitWorkerJobs/gqls";
import type { JobListFilters, JobSortOrder, SortDirection } from "~/features/dbpjkitWorkerJobs/types";
import { buildJobsVariables } from "~/features/dbpjkitWorkerJobs/utils/transformers";
import { useTenant } from "~/features/tenant/context";

interface UseDbpjkitWorkerJobListArgs {
  filters: JobListFilters;
  sortOrder: JobSortOrder;
  direction: SortDirection;
  pageIndex: number;
  pageSize: number;
}

/** Server-paginated jobs list for the current tenant (V1 parity). */
export function useDbpjkitWorkerJobList({
  filters,
  sortOrder,
  direction,
  pageIndex,
  pageSize,
}: UseDbpjkitWorkerJobListArgs) {
  const { tenantId } = useTenant();
  if (!tenantId) throw new Error("Tenant ID is required");
  return useSuspenseQuery<GetDbpjKitWorkerJobsQuery, GetDbpjKitWorkerJobsQueryVariables>(GetDbpjKitWorkerJobsDocument, {
    variables: buildJobsVariables({ tenantId, filters, sortOrder, direction, pageIndex, pageSize }),
  });
}
